<template>
  <RevLoadingScreen
    v-if="isRedirecting"
    class="bg-surface-default-mid fixed inset-0"
    :text="''"
  />

  <RevInfoBlock
    v-else
    class="m-24"
    :content="i18n(translations.errorContent)"
    :icon="IconWarning"
    :title="i18n(translations.errorTitle)"
    variant="danger"
  >
    <RevButton class="mt-16" :to="{ name: CHECKOUT.CART }" variant="primary">
      {{ i18n(translations.backToCart) }}
    </RevButton>
  </RevInfoBlock>
</template>

<script setup lang="ts">
import { navigateTo, useRoute } from '#imports'
import { ref } from 'vue'

import type { BuybackOffer } from '@backmarket/http-api/src/api-models/BuybackOffer'
import { getSelectedMobilePlan } from '@backmarket/nuxt-layer-checkout/utils/mobilePlan/getSelectedMobilePlan'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { RevButton } from '@ds/components/Button'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'
import { IconWarning } from '@ds/icons/IconWarning'

import { CHECKOUT } from '~/scopes/checkout/routes-names'

import translations from './ServicesRoot.translations'

const props = defineProps<{
  items: ApiSpecs['/bm/cart']['GET']['response']['cartItems']
  swapOffer: BuybackOffer | null
}>()

const i18n = useI18n()
const logger = useLogger()
const route = useRoute()
const isRedirecting = ref(true)

const isPhonelineSetupStep = route.query.step === 'phoneline-setup'

const selectedMobilePlan = getSelectedMobilePlan(props.items, {
  type: 'ONLINE',
})

if (!selectedMobilePlan) {
  isRedirecting.value = false

  logger.error('[PARTNERSHIPS] No online mobile plan found in services root')
} else {
  const partnerName = selectedMobilePlan.partner.name

  if (partnerName === 'BOUYGUES_TELECOM') {
    navigateTo(
      isPhonelineSetupStep
        ? { name: CHECKOUT.SERVICES.BOUYGUES.PHONELINE_SETUP }
        : { name: CHECKOUT.SERVICES.BOUYGUES.ROOT },
    )
  } else if (partnerName === 'FREENET') {
    navigateTo({ name: CHECKOUT.SERVICES.FREENET.ROOT })
  } else {
    isRedirecting.value = false

    logger.error(
      '[PARTNERSHIPS] Unknown mobile plan partner in services root',
      {
        attributes: {
          offerId: selectedMobilePlan.id,
          partnerName,
        },
      },
    )
  }
}
</script>
